import * as yup from "yup";

export const partnershipCompanySchema = (
    t: (val: string) => string,
    isFormOpen = false
) => {
    if (!isFormOpen) {
        return yup.object().shape({
            firstName: yup.string().notRequired(),
            lastName: yup.string().notRequired(),
            email: yup.string().notRequired(),
        });
    }
    const validation = {
        firstName: yup.string().required(t("cmn:val.required")),
        lastName: yup.string().required(t("cmn:val.required")),
        email: yup
            .string()
            .required(t("cmn:val.required"))
            .email(t("ent.User:email.val.email")),
    };

    return yup.object().shape({ ...validation });
};
